import { SavedWordData, WordData } from '@shared/types/words';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { wordsLoadingAtom, wordsLoadMoreAtom, wordToDeleteAtom, wordToSaveAtom } from '@app/atoms/wordsAtoms';
import './WordsListView.scss';
import { useAtomValue, useSetAtom } from 'jotai';
import SwipeableWordItem from './SwipeableWordItem';
import { useEffect } from 'react';

const WordsListView = ({ wordsData, collectionId, loadMoreEnabled, onClose }: { wordsData: WordData[] | SavedWordData[], collectionId?: string, loadMoreEnabled: boolean, onClose?: () => void }) => {
  const wordsLoading = useAtomValue(wordsLoadingAtom);
  const dispatchLoadMore = useSetAtom(wordsLoadMoreAtom);
  const setWordToDelete = useSetAtom(wordToDeleteAtom);
  const setWordToSave = useSetAtom(wordToSaveAtom);
  const handleOnClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || wordsLoading) {
        return;
      }
      event.preventDefault();
      handleOnClose();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [wordsLoading]);

  const handleLoadMoreCards = () => {
    if (wordsLoading) {
      return;
    }

    dispatchLoadMore();
  };

  const handleDeleteWord = async (word: WordData | SavedWordData) => {
    const savedWordId = (word as SavedWordData).savedData?.id;
    if (!collectionId || !savedWordId) {
      return;
    }

    setWordToDelete({ savedWordId, collectionId });
  };

  const handleSaveWord = (word: WordData) => {
    if (word.saved) {
      return;
    }
    setWordToSave(word);
  };

  return (<div className="modal words-list-modal" style={{display: 'block'}}>
    <div className="modal-dialog modal-fullscreen words-list-modal__dialog">
      <div className="modal-content words-list-modal__content">
        <div className="modal-header">
          <h5 className="modal-title">Important Words</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleOnClose} disabled={wordsLoading}></button>
        </div>
        <div className="modal-body words-list-modal__body">
          <div className="words-list-view">
            {wordsData.length > 0 && (
              <ol className="important-words">
                {wordsData.map((wordData) => (
                  <SwipeableWordItem 
                    key={wordData.id} 
                    wordData={wordData} 
                    onDelete={collectionId ? handleDeleteWord : undefined}
                    onSave={!collectionId ? handleSaveWord : undefined}
                  />
                ))}
              </ol>
            )}
          </div>
          {loadMoreEnabled && (<Button variant="primary" onClick={handleLoadMoreCards} disabled={wordsLoading}>
            <span>Load more</span>&nbsp;
            {wordsLoading && <Spinner animation="border" size="sm"/>}
          </Button>)}
        </div>
      </div>
    </div>
  </div>);
}

export default WordsListView;
